export const TOKEN_KEY = 'temp_token';
export const TOKEN = 'Blade-Auth';
export const AUTHORIZATION = 'Authorization';
export const TENANT_ID_KEY = 'Tenant-Id';
export const SHOP_ID_KEY = 'Shop-Id';
